// extracted by mini-css-extract-plugin
export default {"root":"IconKitchen_root__YhUMm"};